export function prependBrazilCountryCode (phoneNumber: string): string {
  if (!phoneNumber.startsWith('+55')) {
    return `+55${phoneNumber}`
  }
  return phoneNumber
}
